(function () {
  'use strict';

  angular.module('app.behavior-analytics', [
    'app.behavior-analytics.quickview',
    'app.behavior-analytics.subject-grade-comparisons',
    'app.behavior-analytics.teacher-comparisons',
    'app.behavior-analytics.teacher-details',
  ]);

})();